import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Grid, Navigation, Pagination } from 'swiper/modules';
export default class ProductSlider {
    constructor() {
        this.section = document.querySelector('.components-block-products-slider');
        this.slider = this.section.querySelector('.swiper--components-block-products-slider');
        this.navigationPrev = document.querySelector('.slider-button-prev--components-block-products-slider');
        this.navigationNext = document.querySelector('.slider-button-next--components-block-products-slider');
        this.pagination = this.section.querySelector('.swiper-pagination-nav--components-block-products-slider');

        this.ready();
    }

    ready() {
        let options = {
            modules: [Navigation, Pagination, Grid],
            grabCursor: true,
            slidesPerView: 3,
            spaceBetween: 30,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    grid: {
                        fill: 'row',
                        rows: 1,
                    },
                    pagination: {
                        el: this.pagination,
                        type: 'fraction',
                    },
                },
                1024: {
                    slidesPerView: 3,
                    pagination: '',
                },
            },
        };

        if (this.slider.classList.contains('2line')) {
            options.grid = {
                fill: 'row',
                rows: 2,
            };
        }

        const swiper = new Swiper(this.slider, options);
    }
}

if (document.querySelector('.components-block-products-slider')) {
    new ProductSlider();
}
